import React from 'react';

const ForgotPassword = () => {
	return(
		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
			<h1>Reset Password Link Has Been Send To Yor Email </h1>
		</div>
	);
}

export default ForgotPassword